import Title, { caption } from './Title.svelte'

export default {
    set: (title) => caption.set(title)
}